type ForgotPasswordStateCardProps = {
  hint: string
  actionLabel: string
  actionHref: string
}

export const ForgotPasswordStateCard = ({
  hint,
  actionLabel,
  actionHref,
}: ForgotPasswordStateCardProps) => (
  <div className="space-y-4">
    <p className="text-sm leading-relaxed text-(--color-text-secondary)">{hint}</p>
    <a
      href={actionHref}
      className="ca-btn-primary inline-flex h-11 w-full items-center justify-center px-4 text-sm font-semibold shadow-[0_10px_24px_-18px_color-mix(in_srgb,var(--color-action-primary)_85%,transparent)] transition-colors duration-200"
    >
      {actionLabel}
    </a>
  </div>
)
